<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,8C16,7.63,15.79,7.32,15.49,7.15C15.49,7.15,15.5,7.14,15.5,7.14C15.5,7.14,8.5,3.14,8.5,3.14C8.5,3.14,8.49,3.15,8.49,3.15C8.34,3.06,8.18,3,8,3C7.82,3,7.66,3.06,7.51,3.15C7.51,3.15,7.5,3.13,7.5,3.13C7.5,3.13,0.5,7.13,0.5,7.13C0.5,7.13,0.51,7.14,0.51,7.14C0.21,7.32,0,7.63,0,8C0,8.370000000000001,0.21,8.68,0.51,8.85C0.51,8.85,0.5,8.86,0.5,8.86C0.5,8.86,7.5,12.86,7.5,12.86C7.5,12.86,7.51,12.85,7.51,12.85C7.66,12.94,7.82,13,8,13C8.18,13,8.34,12.94,8.49,12.85C8.49,12.85,8.5,12.86,8.5,12.86C8.5,12.86,15.5,8.86,15.5,8.86C15.5,8.86,15.49,8.85,15.49,8.85C15.79,8.68,16,8.370000000000001,16,8C16,8,16,8,16,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Layer',
} as DefineComponent
</script>
